import { useCallback } from "react";
import { useRecoilState } from "recoil";

import { ClipQualitySettingsModalOpen } from "MVVM/State";

export const useClipQualitySettingsModal = () => {
  const [isOpen, setIsOpen] = useRecoilState(ClipQualitySettingsModalOpen);

  const open = useCallback(() => setIsOpen(true), [setIsOpen]);
  const close = useCallback(() => setIsOpen(false), [setIsOpen]);

  return { isOpen, open, close };
};
